import Vue from 'vue';
import clickOutside from './clickOutside';
import overflowTooltip from './overflowTooltip';

export default {};

// Make directives available globally
Vue.directive('click-outside', clickOutside);
Vue.directive('overflow-tooltip', overflowTooltip);
